import { Part, Profile } from '../features/profile/types';

export function isVisible(profile: Profile, part?: Part | null) {
    if (!part) {
        return true;
    }
    
    return profile.parts.indexOf(part) >= 0;
}
